// src/pages/RegistroIntermedio.jsx
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import {
    Button,
    TextField,
    FormControlLabel,
    FormGroup,
    Checkbox,
    FormControl,
    Select,
    MenuItem,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import "../components/AceternityForm/AceternityForm.css";
import {
    aceternityTextFieldSx,
    aceternitySelectSx,
    aceternityMenuPaperSx,
    aceternityCheckboxSx,
} from "../components/AceternityForm/aceternityTextFieldSx";
import BorderGlow from "../components/BorderGlow/BorderGlow";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { registrarUsuario } from "../services/posUsers";
import { getUserByEmail } from "../services/login";

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
const isValidTelefono = (telefono) => /^[245678]\d{7}$/.test(telefono);

const RegistroIntermedio = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const googleData = location.state?.googleData || {};

    const [paginaExtraInfo, setPaginaExtraInfo] = useState("none");
    const [paginaBasica, setPaginaBasica] = useState("flex");
    const [esEstudiante, setEsEstudiante] = useState("none");

    const [formData, setFormData] = useState({
        nombre: googleData.given_name || "",
        apellidos: googleData.family_name || "",
        correo: googleData.email || "",
        telefono: "",
        direccion: "",
        esEstudiante: "",
        carrera: "",
        carne: "",
    });

    const carreras = ["Computadores", "Mecatrónica", "Electrónica", "Otra"];

    const [emailError, setEmailError] = useState(false);
    const [telefonoError, setTelefonoError] = useState(false);

    const handleChangeEstudiante = (event) => {
        const isChecked = event.target.checked;
        setEsEstudiante(isChecked ? "flex" : "none");

        setFormData((prev) => ({
            ...prev,
            esEstudiante: isChecked ? "1" : "0",
            carrera: isChecked ? prev.carrera : "",
            carne: isChecked ? prev.carne : "",
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        if (name === "correo") setEmailError(!isValidEmail(value));
        if (name === "telefono") setTelefonoError(!isValidTelefono(value));
    };

    const handleEnterBasicInfo = () => {
        const nombreValido = formData.nombre.length > 0;
        const apellidoValido = formData.apellidos.length > 0;
        const correoValido = isValidEmail(formData.correo);
        const telefonoValido = isValidTelefono(formData.telefono);
        if (nombreValido && apellidoValido && correoValido && telefonoValido) {
            setPaginaBasica("none");
            setPaginaExtraInfo("flex");
        }
    };

    const handleReturnToBasics = () => {
        setPaginaBasica("flex");
        setPaginaExtraInfo("none");
    };

    const [openConfirmModal, setOpenConfirmModal] = useState(false);

    const handleConfirmOpen = () => {
        setOpenConfirmModal(true);
    };

    const handleConfirmClose = async () => {
        setOpenConfirmModal(false);
        await handleSubmit();
        navigate("/perfil");
    };

    const handleSubmit = async () => {
        try {
            const userData = {
                request_data: {},
                name: `${formData.nombre} ${formData.apellidos}`,
                name_alias: formData.carne || "",
                client: "1",
                idprof1: "GOOGLE", // marca que fue creado por Google
                idprof2: formData.carrera || "",
                email: formData.correo,
                phone: formData.telefono,
            };

            await registrarUsuario(userData);

            // Buscar el Customer recién creado en Frappe por correo
            const usuario = await getUserByEmail(formData.correo);

            if (usuario) {
                localStorage.setItem("user", JSON.stringify(usuario));
            } else {
                alert("No se pudo obtener el usuario luego del registro.");
            }
        } catch (error) {
            console.error("Error al registrar usuario:", error);
        }
    };

    return (
        <>
            <Header />
            <div className="aceternity-form-page">
                <div className="aceternity-form-wrapper">
                    <BorderGlow className="aceternity-glow-wrap" borderRadius={16} backgroundColor="transparent">
                    <div className="aceternity-form-card">
                        <h2 className="aceternity-form-title">Completa tu cuenta Volteon</h2>
                        <p className="aceternity-form-subtitle">
                            Solo unos datos más y podrás disfrutar de todas nuestras funciones.
                        </p>

                        {/* Página básica */}
                        <div className="aceternity-form" style={{ display: paginaBasica }}>
                            <div className="aceternity-form-row">
                                <TextField
                                    required
                                    label="Nombre"
                                    name="nombre"
                                    value={formData.nombre}
                                    onChange={handleInputChange}
                                    variant="filled"
                                    fullWidth
                                    sx={aceternityTextFieldSx}
                                />
                            </div>

                            <div className="aceternity-form-row">
                                <TextField
                                    required
                                    label="Apellidos"
                                    name="apellidos"
                                    value={formData.apellidos}
                                    onChange={handleInputChange}
                                    variant="filled"
                                    fullWidth
                                    sx={aceternityTextFieldSx}
                                />
                            </div>

                            <div className="aceternity-form-row">
                                <TextField
                                    required
                                    label="Correo electrónico"
                                    name="correo"
                                    value={formData.correo}
                                    disabled
                                    variant="filled"
                                    fullWidth
                                    sx={aceternityTextFieldSx}
                                />
                            </div>

                            <div className="aceternity-form-row">
                                <TextField
                                    required
                                    error={telefonoError}
                                    helperText={
                                        telefonoError ? "Número no válido en Costa Rica" : ""
                                    }
                                    label="Teléfono"
                                    name="telefono"
                                    value={formData.telefono}
                                    onChange={handleInputChange}
                                    variant="filled"
                                    fullWidth
                                    sx={aceternityTextFieldSx}
                                />
                            </div>

                            <button className="aceternity-btn-primary" onClick={handleEnterBasicInfo}>
                                Verificar y continuar &rarr;
                            </button>
                        </div>

                        {/* Página extra */}
                        <div className="aceternity-form" style={{ display: paginaExtraInfo }}>
                            <FormGroup>
                                <FormControlLabel
                                    control={<Checkbox sx={aceternityCheckboxSx} onChange={handleChangeEstudiante} />}
                                    label="¿Eres estudiante Tec?"
                                    sx={{ color: "rgba(255,255,255,0.85)" }}
                                />
                            </FormGroup>

                            {esEstudiante === "flex" && (
                                <>
                                    <div className="aceternity-form-row">
                                        <label className="aceternity-label">Carrera</label>
                                        <FormControl fullWidth>
                                            <Select
                                                name="carrera"
                                                value={formData.carrera}
                                                onChange={handleInputChange}
                                                displayEmpty
                                                size="small"
                                                sx={aceternitySelectSx}
                                                MenuProps={{ PaperProps: { sx: aceternityMenuPaperSx } }}
                                            >
                                                {carreras.map((carrera, i) => (
                                                    <MenuItem key={i} value={carrera}>
                                                        {carrera}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>

                                    <div className="aceternity-form-row">
                                        <TextField
                                            required
                                            label="Carné"
                                            name="carne"
                                            value={formData.carne}
                                            onChange={handleInputChange}
                                            variant="filled"
                                            fullWidth
                                            sx={aceternityTextFieldSx}
                                        />
                                    </div>
                                </>
                            )}

                            <div style={{ display: "flex", gap: "1rem" }}>
                                <button className="aceternity-btn-secondary" onClick={handleReturnToBasics}>
                                    Volver
                                </button>
                                <button className="aceternity-btn-primary" onClick={handleConfirmOpen}>
                                    Terminar &rarr;
                                </button>
                            </div>
                        </div>
                    </div>
                    </BorderGlow>
                </div>
            </div>

            <Dialog open={openConfirmModal} onClose={handleConfirmClose}>
                <DialogTitle>Confirmar información</DialogTitle>
                <DialogContent style={{ padding: "40px" }}>
                    <DialogContentText>
                        Nombre: {formData.nombre} {formData.apellidos}
                    </DialogContentText>
                    <DialogContentText>Correo: {formData.correo}</DialogContentText>
                    {formData.esEstudiante === "1" && (
                        <>
                            <DialogContentText>Carrera: {formData.carrera}</DialogContentText>
                            <DialogContentText>Carné: {formData.carne}</DialogContentText>
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirmModal(false)}>Volver</Button>
                    <Button onClick={handleConfirmClose} autoFocus>
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
            <Footer />
        </>
    );
};

export default RegistroIntermedio;
